<template>
  <div>
    <section
      class="sidebar"
      :class="{ 'sidebar-hidden': !isSidebarOpen }"
    >
      <button class="toggle-btn" @click="toggleSidebar">
        <img
          :src="isSidebarOpen
            ? '/image/icon/menu.svg'
            : '/image/icon/close.svg'"
          alt="toggle menu"
        />
      </button>
      <div class="icons-section">
        <router-link :to="{ name: 'landingPage' }">
          <div>
            <img
              :class="{ active: $route.path == '/' }"
              src="@/../public/image/icon/home.svg"
              alt="home"
            />
            <span class="icon-text">Home</span>
          </div>
        </router-link>

        <router-link :to="{ name: 'eventPage' }">
          <div class="icon-child">
            <img
              :class="{ active: $route.path == '/event' }"
              src="@/../public/image/icon/list.svg"
              alt="event"
            />
            <span class="icon-text">Event</span>
          </div>
        </router-link>

        <router-link :to="{ name: 'pdf' }">
          <div class="icon-child">
            <img
              :class="{ active: $route.path == '/pdf' }"
              src="@/../public/image/icon/file-text.svg"
              alt="pdf"
            />
            <span class="icon-text">PDF</span>
          </div>
        </router-link>

        <router-link :to="{ name: 'video' }">
          <div class="icon-child">
            <img
              :class="{ active: $route.path == '/video' }"
              src="@/../public/image/icon/video.svg"
              alt="video"
            />
            <span class="icon-text">Video</span>
          </div>
        </router-link>

        <router-link :to="{ name: 'Notification' }">
          <div class="icon-child">
            <img
              :class="{ active: $route.path == '/Notification' }"
              src="@/../public/image/icon/bell.svg"
              alt="notification"
            />
            <span class="icon-text">Notification</span>
          </div>
        </router-link>

        <router-link :to="{ name: 'Holliday' }">
          <div class="icon-child">
            <img
              :class="{ active: $route.path == '/Holliday' }"
              src="@/../public/image/icon/calendar.svg"
              alt="holiday"
            />
            <span class="icon-text">Holiday</span>
          </div>
        </router-link>

        <div class="icon-child" @click="signOut" style="cursor: pointer">
          <img
            src="@/../public/image/icon/log-out.svg"
            alt="logout"
            class="white-icon"
          />
          <span class="icon-text">Logout</span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      isSidebarOpen: true,
    };
  },
  methods: {
    ...mapActions({
      signOutAction: "auth/signOut",
    }),

    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },

    // Logout function
    signOut() {
      this.signOutAction()
        .then(() => {
          this.$notify.success({
            position: "bottom right",
            msg: "Logout successfully!",
            timeout: 2000,
            styles: {
              minWidth: null,
              maxWidth: "calc(100% - 40px)",
              width: 250,
              height: 70,
            },
          });
          this.$router.replace({ name: "Login" });
        })
        .catch(() => {
          this.$notify.error({
            position: "bottom right",
            msg: "Could not logout!",
            timeout: 2000,
            styles: {
              minWidth: null,
              maxWidth: "calc(100% - 40px)",
              width: 250,
              height: 70,
            },
          });
        });
    },
  },
};
</script>

<style scoped>
.sidebar {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100vh;
  min-width: 200px;
  max-width: 200px;
  background: #254594;
  transition: transform 0.3s ease-in-out;
}

.sidebar-hidden {
  transform: translateX(100%);
}

.toggle-btn {
  position: absolute;
  top: 20px;
  left: -40px;
  background: #254594;
  border: none;
  outline: none;
  padding: 10px;
  cursor: pointer;
  border-radius: 50%;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}

.toggle-btn img {
  width: 20px;
  height: 20px;
}

.icon-text {
  color: #fff;
  margin-left: 20px;
}

.icon-child {
  margin-top: 25px;
}

.icons-section {
  margin-top: 60px;
}

.active {
  margin-left: 10px;
}
.white-icon {
  filter: invert(100%) brightness(100%) grayscale(100%);
}

/* Responsive Design */
@media (max-width: 768px) {
  .sidebar {
    transform: translateX(100%);
  }

  .sidebar.sidebar-hidden {
    transform: translateX(0);
  }
}
</style>
